import { put, select, takeLatest } from 'redux-saga/effects'

import { actionTypes } from '@signavio/kraken'

import { logout } from '../actions'
import { getCurrentOrgKey } from '../callApi'
import { isLoggedInSessionState, SessionSagaReturnType } from '../../types'

interface Action {
  type: string
  payload?: { status?: number; error?: string }
}

export function* filterFailedRequest(action: Action): SessionSagaReturnType {
  const session = yield select((state) => state.session)
  const storedOrganizationKey = getCurrentOrgKey()

  if (!isLoggedInSessionState(session)) {
    return
  }

  if (storedOrganizationKey) {
    return
  }

  if (action.payload && action.payload.status === 400) {
    yield put(logout())
  }
}

export default function* watchIsFailedRequestUnauthorized() {
  yield takeLatest(
    [
      actionTypes.CREATE_FAILURE,
      actionTypes.FETCH_FAILURE,
      actionTypes.UPDATE_FAILURE,
      actionTypes.REMOVE_FAILURE,
    ],
    filterFailedRequest
  )
}
